export default () => ({
  async decreaseQty(lineId, lineQty, isGiftItem = false) {
    let quantity = lineQty - 1;
    const updates = {
      [lineId]: quantity,
    };
    
    // If gift item is manually remvoed, prevent it from automatically adding back to cart
    if (isGiftItem && quantity === 0) {
      window.sessionStorage.setItem('giftItemManuallyRemoved', 'true');
    }
    
    await this.$store.cart.updateLines(updates);
  },
  async increaseQty(lineId, lineQty, isGiftItem = false) {
    // Prevent free gift from being added multiple times
    if (isGiftItem && lineQty >= 1) {
      return;
    }
    
    let quantity = lineQty + 1;
    const updates = {
      [lineId]: quantity,
    };
    await this.$store.cart.updateLines(updates);
  },
});
